export const WELCOME = 'Welcome';
export const CONNECTED = 'connected';
export const CONNECT_USER = 'ConnectUser';
export const CONNECT_USER_SUCCESS = 'ConnectUserSuccess';
export const CONNECT_USER_ERROR = 'ConnectUserError';
export const RECONNECT = 'reconnect';
